<span class="sr-only">
  <ng-content></ng-content>
</span>

